// extracted by mini-css-extract-plugin
module.exports = {"gas":"Tx_gas__1uOXk","select":"Tx_select__2bUMM","icon":"Tx_icon__3pzHB","hidden":"Tx_hidden__3Zboq"};